import MessagePanel from './MessagePanel';

export default MessagePanel;
